export default 'UPDATE_HINTING';



// WEBPACK FOOTER //
// ../../src/hinting/actionType.js